import React, { useState, useEffect } from 'react';

import Sides from '../Bars/Pythonsidebar';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Pfunction() {

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }


 
  return (
    <div>

      <Sides />
      <Helmet>

        <title>Learn Free Python Function Beginners Tutorials CodeExampler</title>
        <meta name="description" content="Python function tutorial for beginners.Function break our program into smaller our modules means a small piece that you can use to build a large program. The def keyword is used to define a function and you use or call the function by using its name." />
        <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,Python Function,Python Function def,Python Function list,Python Function return,Python Function arguments,Python Function  with arguments ,Python Function Parameters,Python Function examples
,Python Function Programs,Python Function input,Python in Function,Python Function overloading
,Function overloading in Python,Function overloading in Python example" />
        <link rel="canonical" href="https://www.codeexampler.com/python-function" />
      </Helmet>

      <div className='lg:pl-56'>

        <h1 className="m-4 mh1">Python Function</h1>

        <div className="first">
          <a href="/python-searching">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a>
          <a href="/python-function-argument">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a>
        </div>

        <p className="mt-4 para">The<span className="bold" > def</span> keyword uses to define a function, and you use or call the function by using its name.</p>



        <h2 className='headings'>Q-Creating a function example?</h2>
        <div style={{ background: "#0f0e33", width: "94%", marginLeft: "3%", paddingLeft: "2%", borderRadius: "20px" }} >
          <pre style={{ maxHeight: "500vh" }}>
            <code >
              {"\n"}
              <span className="qwerty">def </span>
              <span className="qwerty-8">names</span>
              <span className="qwerty-1">()</span>
              <span className="qwerty-1">:</span>
              {"\n"}
              <span className="qwerty-3">    print</span>
              <span className="qwerty-1">("</span>
              <span className="qwerty-10">code</span>
              <span className="qwerty-1">")</span>
              {"\n"}
              <span className="qwerty-8">names</span>
              <span className="qwerty-1">()</span>
              {"\n"}
              <span className="qwerty-3">print</span>
              <span className="qwerty-1">("</span>
              <span className="qwerty-10">Exampler</span>
              <span className="qwerty-1">")</span>
              {"\n"}{"\n"}
            </code>
          </pre>
        </div>
        <h5 className='headings'> Output : </h5>
        <div style={{ background: "#0f0e33", width: "94%", marginLeft: "3%", paddingLeft: "2%", borderRadius: "20px" }} >
          <pre style={{ maxHeight: "500vh" }}>
            <code >
              {"\n"}
              <span className="qwerty-3">code</span>
              {"\n"}
              <span className="qwerty-2">Exampler</span>
              {"\n"}      {"\n"}
            </code>
          </pre>
        </div>

        <h2 className="mt-4 mh2">Python Basics of this Function program</h2>
        <p className="mt-4 para">1, Start from the main program<br />
          2, name()- is used for calls the function<br />
          3, def name() – after calling the function, we jump to the first line of code in the function. Execute all lines inside this function, and after the complete function check, we continue where we left off the main program</p>

        <h2 className="mt-4 mh2">Python Function Basics</h2>
        <p className="mt-4 para">We defined a function. The parentheses hold that information. But in this case, the function names () needs no information, so these parentheses are empty.<br />

          We call a function by using its name and a set of parentheses <br />
          Calling function running the code that is inside the function.  If we define a function but never call it so, code will never run.<br />
        </p>

        
        
        <h2 className='headings'>Q-Define a World Dunction and Print in Python function example?</h2>
        <div style={{ background: "#0f0e33", width: "94%", marginLeft: "3%", paddingLeft: "2%", borderRadius: "20px" }} >
          <pre style={{ maxHeight: "500vh" }}>
            <code >
              {"\n"}
              <span className="qwerty">def </span>
              <span className="qwerty-8">world</span>
              <span className="qwerty-1">()</span>
              <span className="qwerty-1">:</span>
              {"\n"}
              <span className="qwerty-3">    print</span>
              <span className="qwerty-1">("</span>
              <span className="qwerty-10">hello world</span>
              <span className="qwerty-1">")</span>
              {"\n"}
              <span className="qwerty-3">    print</span>
              <span className="qwerty-1">("</span>
              <span className="qwerty-10">world is so beautiful</span>
              <span className="qwerty-1">")</span>
              {"\n"}
              <span className="qwerty-8">world</span>
              <span className="qwerty-1">()</span>
              {"\n"}
              <span className="qwerty-3">print</span>
              <span className="qwerty-1">("</span>
              <span className="qwerty-10">this is a world</span>
              <span className="qwerty-1">")</span>
              {"\n"}{"\n"}
            </code>
          </pre>
        </div>
        <h5 className='headings'> Output : </h5>
        <div style={{ background: "#0f0e33", width: "94%", marginLeft: "3%", paddingLeft: "2%", borderRadius: "20px" }} >
          <pre style={{ maxHeight: "500vh" }}>
            <code >
              {"\n"}
              <span className="qwerty-4">hello world</span>
              {"\n"}
              <span className="qwerty-4">world is so beautiful</span>
              {"\n"}
              <span className="qwerty-2">this is a world</span>
              {"\n"}      {"\n"}
            </code>
          </pre>
        </div>


      

        <h2 className='headings'>Q-If I want to go to the USA after travelling to the UK, and I want to go to Mathura in India?</h2>
        <div style={{ background: "#0f0e33", width: "94%", marginLeft: "3%", paddingLeft: "2%", borderRadius: "20px" }} >
          <pre style={{ maxHeight: "500vh" }}>
            <code >
              {"\n"}
              <span className="qwerty">def </span>
              <span className="qwerty-8">India</span>
              <span className="qwerty-1">()</span>
              <span className="qwerty-1">:</span>
              {"\n"}
              <span className="qwerty-3">    print</span>
              <span className="qwerty-1">("</span>
              <span className="qwerty-10">1 Mathura in INDIA</span>
              <span className="qwerty-1">")</span>
              {"\n"}
              <span className="qwerty">def </span>
              <span className="qwerty-8">UK</span>
              <span className="qwerty-1">()</span>
              <span className="qwerty-1">:</span>
              {"\n"}
              <span className="qwerty-4">    India</span>
              <span className="qwerty-1">()</span>
              {"\n"}
              <span className="qwerty-3">    print</span>
              <span className="qwerty-1">("</span>
              <span className="qwerty-10">2 UK</span>
              <span className="qwerty-1">")</span>
              {"\n"}
              <span className="qwerty-4">    USA</span>
              <span className="qwerty-1">()</span>
              {"\n"}
              <span className="qwerty">def </span>
              <span className="qwerty-8">USA</span>
              <span className="qwerty-1">()</span>
              <span className="qwerty-1">:</span>
              {"\n"}
              <span className="qwerty-3">    print</span>
              <span className="qwerty-1">("</span>
              <span className="qwerty-10">3 USA</span>
              <span className="qwerty-1">")</span>
              {"\n"}
              <span className="qwerty-3">    print</span>
              <span className="qwerty-1">("</span>
              <span className="qwerty-10">Let's get started the journey</span>
              <span className="qwerty-1">")</span>
              {"\n"}
              <span className="qwerty-8">UK</span>
              <span className="qwerty-1">()</span>
              {"\n"}
              <span className="qwerty-3">print</span>
              <span className="qwerty-1">("</span>
              <span className="qwerty-10">Go home</span>
              <span className="qwerty-1">")</span>
              {"\n"}{"\n"}
            </code>
          </pre>
        </div>
        <h5 className='headings'> Output : </h5>
        <div style={{ background: "#0f0e33", width: "94%", marginLeft: "3%", paddingLeft: "2%", borderRadius: "20px" }} >
          <pre style={{ maxHeight: "500vh" }}>
            <code >
              {"\n"}
              <span className="qwerty-7">1 Mathura in INDIA</span>
              {"\n"}
              <span className="qwerty-3">2 UK</span>
              {"\n"}
              <span className="qwerty-4">3 USA</span>
              {"\n"}
              <span className="qwerty-4">Let's get started the  journey</span>
              {"\n"}
              <span className="qwerty-2">Go home</span>
              {"\n"}      {"\n"}
            </code>
          </pre>
        </div>


     
       

        <h2 className='headings'>Q-Repeat one line multiple times in a function program?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty">def </span>
                 <span className="qwerty-8">line</span>
                 <span className="qwerty-1">()</span>
                 <span className="qwerty-1">:</span>
                 {"\n"}
                 <span className="qwerty-7">    for </span>
                 <span className="qwerty-4">i </span>
                 <span className="qwerty-5">in </span>
                 <span className="qwerty-6">range</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">1</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-1">3</span>
                 <span className="qwerty-1">):</span>
                 {"\n"}
                 <span className="qwerty-3">        print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">cow</span>
                 <span className="qwerty-1">")</span>
                 {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">Code Exampler</span>
                 <span className="qwerty-1">")</span>
                 {"\n"}
                 <span className="qwerty-8">line</span>
                 <span className="qwerty-1">()</span>
                 {"\n"}
                 <span className="qwerty-8">line</span>
                 <span className="qwerty-1">()</span>
                 {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">Har Har Mahadev</span>
                 <span className="qwerty-1">")</span>
                 {"\n"}
                 <span className="qwerty-8">line</span>
                 <span className="qwerty-1">()</span>
                 {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">Khalsa</span>
                 <span className="qwerty-1">")</span>
                 {"\n"}
                 <span className="qwerty-8">line</span>
                 <span className="qwerty-1">()</span>
                 {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">Ram-Ram</span>
                 <span className="qwerty-1">")</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"500vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty-4">Code Exampler</span>
                     {"\n"}
                         <span className="qwerty-2">cow</span>
                     {"\n"}
                         <span className="qwerty-2">cow</span>
                     {"\n"}
                         <span className="qwerty-2">cow</span>
                     {"\n"}
                         <span className="qwerty-2">cow</span>
                     {"\n"}
                         <span className="qwerty-4">Har Har Mahadev</span>
                     {"\n"}
                         <span className="qwerty-2">cow</span>
                     {"\n"}
                         <span className="qwerty-2">cow</span>
                     {"\n"}
                         <span className="qwerty-4">Khalsa</span>
                     {"\n"}
                         <span className="qwerty-2">cow</span>
                     {"\n"}
                         <span className="qwerty-2">cow</span>
                     {"\n"}
                         <span className="qwerty-4">Ram-Ram</span>
                         {"\n"}      {"\n"}      
               </code>
                 </pre>
                 </div>


        <h2 className='headings'>Q-Write a Program to search greater no in a function program?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty">def </span>
                 <span className="qwerty-8">greater</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
                 {"\n"}
                 <span className="qwerty-6">    if</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1">):</span>
                 {"\n"}
                 <span className="qwerty">        return </span>
                 <span className="qwerty-4">a</span>
                 {"\n"}
                 <span className="qwerty-6">    else</span>
                 <span className="qwerty-1">:</span>
                 {"\n"}
                 <span className="qwerty">        return </span>
                 <span className="qwerty-4">b</span>
                 {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-5">int</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">input</span>
                 <span className="qwerty-6">(</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-10">Enter a A no</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-6">)</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-5">int</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">input</span>
                 <span className="qwerty-6">(</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-10">Enter a B no</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-6">)</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-2">g</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-8">greater</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">greater = </span>
                 <span className="qwerty-5">%d</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-2">%g</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"500vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty-2">Enter a A no </span>
                         <span className="qwerty-3">42</span>
                     {"\n"}
                         <span className="qwerty-2">Enter a B no </span>
                         <span className="qwerty-3">658</span>
                     {"\n"}
                         <span className="qwerty-4">greater = </span>
                         <span className="qwerty-8">658 </span>
                         {"\n"}      {"\n"}      
               </code>
                 </pre>
                 </div>

        <h2 className="mt-4 ">Python value by Function Return:</h2>
      

      

        <h2 className='headings'>Q-Maximum value in 3 no in a function program?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty">def </span>
                 <span className="qwerty-8">greater</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">x</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-4">y</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-4">z</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
                 {"\n"}
                 <span className="qwerty-6">    if </span>
                 <span className="qwerty-4">x</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-4">y</span>
                 <span className="qwerty-5"> and </span>
                 <span className="qwerty-4">x</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-4">z</span>
                 <span className="qwerty-1">:</span>
                 {"\n"}
                 <span className="qwerty">        return </span>
                 <span className="qwerty-4">x</span>
                 {"\n"}
                 <span className="qwerty-6">    elif </span>
                 <span className="qwerty-4">y</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-4">x</span>
                 <span className="qwerty-5"> and </span>
                 <span className="qwerty-4">y</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-4">z</span>
                 <span className="qwerty-1">:</span>
                 {"\n"}
                 <span className="qwerty">        return </span>
                 <span className="qwerty-4">y</span>
                 {"\n"}
                 <span className="qwerty-6">    else</span>
                 <span className="qwerty-1">:</span>
                 {"\n"}
                 <span className="qwerty">        return </span>
                 <span className="qwerty-4">z</span>
                 {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-5">int</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">input</span>
                 <span className="qwerty-6">(</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-10">Enter a A no</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-6">)</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-5">int</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">input</span>
                 <span className="qwerty-6">(</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-10">Enter a B no</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-6">)</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-4">c</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-5">int</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">input</span>
                 <span className="qwerty-6">(</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-10">Enter a C no</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-6">)</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-2">max</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-8">greater</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-4">c</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">Maximum No = </span>
                 <span className="qwerty-5">%d</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-2">%max</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"500vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty-2">Enter a A no </span>
                         <span className="qwerty-3">46</span>
                     {"\n"}
                         <span className="qwerty-2">Enter a B no </span>
                         <span className="qwerty-3">44</span>
                     {"\n"}
                         <span className="qwerty-2">Enter a B no </span>
                         <span className="qwerty-3">48</span>
                     {"\n"}
                         <span className="qwerty-4">Maximum No = </span>
                         <span className="qwerty-8">48 </span>
                         {"\n"}      {"\n"}      
               </code>
                 </pre>
                 </div>

     
       


        <p className="mt-4 para">If you don't know about input in Python so check on <a href="https://www.codeexampler.com/python-input"> Python input free tutorial</a>.</p>

        <h2 className="mt-4 mh2">Python Function Recursive</h2>
        <p className="mt-4 para">Recursive function if a function known as by itself and it should under a condition otherwise that will be excited infinite.
        </p>

     

        
        <h2 className='headings'>Q-Python Function Recursive in a function program?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty">def </span>
                 <span className="qwerty-8">display</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">n</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
                 {"\n"}
                 <span className="qwerty-6">    if </span>
                 <span className="qwerty-4">n</span>
                 <span className="qwerty">&#62;=</span>
                 <span className="qwerty-2">1</span>
                 <span className="qwerty-1">:</span>
                 {"\n"}
                 <span className="qwerty-3">        print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">n</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-8">display</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">-4</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-8">display</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">5</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"500vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty-3">5</span>
                         {"\n"}      {"\n"}      
               </code>
                 </pre>
                 </div>

        <h2 className="mt-4 mh2">
          Advantage if Recursion:
        </h2>
        <p className="mt-4 para">1, if Recursion can break a complex task into a smaller subproblem<br />
          2, Sequence generation is easier than looping<br />
        </p>

  

        <h2 className='headings'>Python Function Math Examples:</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty">import </span>
                 <span className="qwerty-8">math</span>
                 {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-8">math</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-4">pi</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"500vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty-2">3.141592653589793</span>
                         {"\n"}      {"\n"}      
               </code>
                 </pre>
                 </div>


        <h2 className="mt-4">Types Of Function:</h2>
        <p className="mt-4 para">This function uses to get the type of a variable.</p>




        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-10">10</span>
             {"\n"}
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-10">2.5</span>
             {"\n"}
                 <span className="qwerty-4">c</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">abc</span>
                 <span className="qwerty-6">'</span>
                 {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-8">type</span>
                 <span className="qwerty-6">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-6">)</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-8">type</span>
                 <span className="qwerty-6">(</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-6">)</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-8">type</span>
                 <span className="qwerty-6">(</span>
                 <span className="qwerty-4">c</span>
                 <span className="qwerty-6">)</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"500vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty-1">&#60;</span>
                         <span className="qwerty-3">class </span>
                         <span className="qwerty-6">'</span>
                         <span className="qwerty-2">int</span>
                         <span className="qwerty-6">'</span>
                         <span className="qwerty-1">&#62;</span>
                     {"\n"}
                         <span className="qwerty-1">&#60;</span>
                         <span className="qwerty-3">class </span>
                         <span className="qwerty-6">'</span>
                         <span className="qwerty-2">float</span>
                         <span className="qwerty-6">'</span>
                         <span className="qwerty-1">&#62;</span>
                     {"\n"}
                         <span className="qwerty-1">&#60;</span>
                         <span className="qwerty-3">class </span>
                         <span className="qwerty-6">'</span>
                         <span className="qwerty-2">str</span>
                         <span className="qwerty-6">'</span>
                         <span className="qwerty-1">&#62;</span>
                         {"\n"}      {"\n"}      
               </code>
                 </pre>
                 </div>


     
    


        <h1 className="mt-5">  </h1>
        <div className="back">
          <a href="/python-searching">  <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a>
          <a href="/python-function-argument">  <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a>
        </div>
      </div>
    </div>
  )

}
export default Pfunction;